import { ImageJwtAxios } from '@/packaging';

export const imageApi = {
  async GetDetailAddImageList() {
    const res = await ImageJwtAxios.get(`/image/GetDetailAddImageList`);
    return res;
  },
  async RemoveDetailAddImage(guid) {
    const res = await ImageJwtAxios.delete(`/image/RemoveDetailAddImage`, guid);
    return res;
  },

  async UploadDetailAddImage(name, guid, body) {
    const res = await ImageJwtAxios.multipart(
      `/image/UploadDetailAddImage?name=${name}&guid=${guid}`,
      body
    );
    return res;
  },
  async uploadMainImage({ guid, code, body }) {
    const res = await ImageJwtAxios.multipart(
      `/image/UploadMainImage?guid=${guid}&code=${code}`,
      body
    );
    return res;
  },
  async removeMainImage(guid) {
    const res = await ImageJwtAxios.delete(`/image/RemoveMainImage`, guid);
    return res;
  },
  async ImageInpaintingAi(image,targetLanguage) {
    const res = await ImageJwtAxios.post(`/image/ImageInpaintingAI?targetLanguage=${targetLanguage}`, image);
    return res;
  },
  async RenderTranslatedText(base64Image, textDatas) {
    const res = await ImageJwtAxios.post(`/image/RenderTranslatedText`, { base64Image, textDatas });
    return res;
  },
  async EraseObject(originalImage, maskImage) {
    const res = await ImageJwtAxios.post(`/image/EraseObject`, { originalImage, maskImage });
    return res;
  },
  async UpscaleImage(base64Image, scale) {
    const res = await ImageJwtAxios.post(`/image/UpscaleImage?scale=${scale}`, base64Image);
    return res;
  },
  async RequestAiImagePriority(guids) {
    const res = await ImageJwtAxios.post(`/image/RequestAiImagePriority`, guids);
    return res;
  },
  async GetAiImagePriorityList() {
    const res = await ImageJwtAxios.get(`/image/GetAiImagePriorityList`);
    return res;
  },
  async DeleteAiImagePriority(idx) {
    const res = await ImageJwtAxios.delete(`/image/DeleteAiImagePriority?idx=${idx}`);
    return res;
  },
  async UpdateAiImagePriorityOrder(orderList) {
    const res = await ImageJwtAxios.post(`/image/UpdateAiImagePriorityOrder`, orderList);
    return res;
  }
};
